import React from 'react';
import { TrackingFunc } from '@withjoy/web-core';
import { Text, Button, Stack } from '@withjoy/joykit';
import { Checkbox } from '@joykit';
import { CheckboxContainer, FormContainer, Form, ButtonContainer, ErrorText } from './styles';

interface QuestionnaireProps {
  track: TrackingFunc;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  options: Option[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSkip: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  error: boolean;
  errorText: string;
}

type Option = {
  label: string;
  checked: boolean;
  name: string;
  telemetryName: string;
};

export class Questionnaire extends React.PureComponent<QuestionnaireProps> {
  render() {
    const { error, errorText, onSubmit, onSkip, onChange, options } = this.props;

    return (
      <Form onSubmit={onSubmit}>
        <FormContainer>
          <Stack spacing={16}>
            <Stack spacing={32}>
              <Text component="h1" variant="page">
                How did you hear about Joy?
              </Text>
              <Text component="p" variant="bodyTitle">
                Check all that apply
              </Text>
            </Stack>
            <div>
              {options.map(option => (
                <CheckboxContainer key={option.name}>
                  <Checkbox
                    data-field={option.name}
                    data-telem={option.telemetryName}
                    data-label={option.label}
                    onChange={onChange}
                    checked={option.checked}
                  />
                  <span style={{ marginLeft: '8px' }}>{option.label}</span>
                </CheckboxContainer>
              ))}
            </div>
            {error && <ErrorText>{errorText}</ErrorText>}
            <ButtonContainer>
              <Button data-button="skip" intent="secondary" onClick={onSkip}>
                Skip
              </Button>
              <Button data-button="submit" type="submit">
                Submit
              </Button>
            </ButtonContainer>
          </Stack>
        </FormContainer>
      </Form>
    );
  }
}
